// Single source of truth for site-wide SEO values.
// SITE_URL must match the domain the site is actually deployed to —
// it feeds canonical tags, Open Graph URLs, and sitemap.xml generation.
export const SITE_URL = "https://www.chemicides.com";
export const SITE_NAME = "Chemicides International";
export const DEFAULT_DESCRIPTION =
    "Chemicides International (Pvt) Ltd — manufacturer of zinc sulphate, chelated zinc, liquid zinc, humic acid and other granular and liquid fertilizers for farmers in Pakistan.";
